import React from 'react';
import styled, {css} from 'styled-components';
import {BsPauseFill} from 'react-icons/bs';
import playIcon from '../img/sprite/track-play.svg';

const StyledButton = styled.button`
  ${props => props.disabled && css`
    pointer-events: none;
    background: #E1E1E1;
  `}
`;

const PlayBtn = ({play=false, onClick, disabled=false}) => {
	return (
		<StyledButton
			className="page__player-play is-paused flex-shrink-0 mr-3"
			type="button"
			onClick={onClick}
			disabled={disabled}
		>
			{
				play
					? <BsPauseFill size={20}/>
					: <img src={playIcon} alt="" width={20} height={20}/>
			}
		</StyledButton>
	);
};

export default PlayBtn;
